// extracted by mini-css-extract-plugin
export default {"grid":"MetricsGrid_grid__mFFN2"};